
import Vue from 'vue';
import { ITreeNode } from '../Itree-node';
import { ITreeNodeEvent } from '../Itree-node-event';
import { TreeNodeEventType } from '../tree-node-event-type';
import TreeViewNodeDisplay from './tux-tree-view-node-display.vue';
import { BRow, BCol } from 'bootstrap-vue';

export default Vue.extend({
	name: 'TreeViewNode',
	components: {
		TreeViewNodeDisplay,
		BRow,
		BCol
	},
	props: {
		value: {
			type: Object as () => ITreeNode,
			required: true,
			default: null
		},
		indentSpacing: {
			type: Number,
			required: false,
			default: 0
		},
		draggable: {
			type: Boolean,
			required: false,
			default: false
		},
		allowDragToSameLevel: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	data() {
		return {
			detailsSlotName: 'node-details' as string,
			nodeDropZoneExpandTimeoutInterval: 1000 as number,
			dragEventDataType: 'text/plain' as string,
			treeNodeEventName: 'tree-node-event' as string,
			overNodeDropZoneBegin: 0 as number,
			isOverNodeDropZone: false as boolean,
			isOverSpacingDropZone: false as boolean,
			isBeingDragged: false as boolean,
			childStyle: {
				paddingLeft: this.indentSpacing + 2
			}
		};
	},
	computed: {
		treeNode(): ITreeNode {
			return this.value;
		},
		childIndentSpacing(): number {
			return this.indentSpacing + 10;
		},
		hasChildren(): boolean {
			return this.treeNode.children != null && this.treeNode.children.length > 0;
		},
		nodeDragListeners(): any {
			if (!this.draggable) {
				return null;
			}

			return {
				dragstart: this.onNodeDragStart,
				dragenter: this.onNodeDropZoneEnter,
				dragover: this.onNodeDropZoneOver,
				dragleave: this.onNodeDropZoneLeave,
				dragend: this.onNodeDragEnd,
				drop: this.onNodeDrop
			};
		},
		spacingDropZoneListeners(): any {
			if (!this.draggable || !this.allowDragToSameLevel) {
				return null;
			}

			return {
				dragover: this.onSpacingDropZoneOver,
				dragleave: this.onSpacingDropZoneLeave,
				drop: this.onNodeDrop
			};
		}
	},
	methods: {
		nodeClicked() {
			this.$emit(this.treeNodeEventName, { eventType: TreeNodeEventType.NodeClicked, node: this.treeNode });
		},
		handleChildNodeEvent(event: ITreeNodeEvent) {
			this.$emit(this.treeNodeEventName, event);
		},
		isSlotDefined(slotName: string, treeNode: ITreeNode) {
			return (this.$scopedSlots as any)[slotName] && (this.$scopedSlots as any)[slotName]({ node: treeNode });
		},
		getNameColumnWidth(treeNode: any) {
			if (this.isSlotDefined(this.detailsSlotName, treeNode)) return 3;
			return 12;
		},
		onNodeDropZoneOver(event: DragEvent) {
			if (!this.isBeingDragged) {
				event.preventDefault();
				this.isOverNodeDropZone = true;

				if (!this.treeNode.isOpened && Date.now() - this.overNodeDropZoneBegin > this.nodeDropZoneExpandTimeoutInterval) {
					this.$emit(this.treeNodeEventName, { eventType: TreeNodeEventType.NodeHandleClicked, node: this.treeNode });
				}
			}
		},
		onNodeDropZoneEnter() {
			this.overNodeDropZoneBegin = Date.now();
		},
		onNodeDropZoneLeave() {
			this.isOverNodeDropZone = false;
		},
		onNodeDrop(event: DragEvent) {
			const droppedOnNode = this.isOverNodeDropZone;
			this.isOverNodeDropZone = false;
			this.isOverSpacingDropZone = false;

			const droppedNodeId = Number(event?.dataTransfer?.getData(this.dragEventDataType));
			if (droppedNodeId !== this.treeNode.id) {
				this.$emit(this.treeNodeEventName, {
					eventType: TreeNodeEventType.NodeDropped,
					targetNodeId: this.treeNode.id,
					droppedNodeId: droppedNodeId,
					droppedOnNode: droppedOnNode
				});
			}

			event?.dataTransfer?.clearData();
		},
		onNodeDragStart(event: DragEvent) {
			this.isBeingDragged = true;
			event?.dataTransfer?.setData(this.dragEventDataType, this.treeNode.id.toString());
			if (this.treeNode.isOpened) {
				this.$emit(this.treeNodeEventName, { eventType: TreeNodeEventType.NodeHandleClicked, node: this.treeNode });
			}
		},
		onNodeDragEnd() {
			this.isBeingDragged = false;
		},
		onSpacingDropZoneOver(event: DragEvent) {
			event.preventDefault();
			this.isOverSpacingDropZone = true;
		},
		onSpacingDropZoneLeave() {
			this.isOverSpacingDropZone = false;
		}
	}
});
